import { useLayoutEffect, useRef, useState } from "react";

interface RotatingWordProps {
  words: string[];
  currentIndex: number;
  className?: string;
  suffix?: string;
}

const RotatingWord = ({ words, currentIndex, className = "", suffix = "" }: RotatingWordProps) => {
  const [width, setWidth] = useState<number>(0);
  const ref = useRef<HTMLSpanElement>(null);

  useLayoutEffect(() => {
    if (ref.current) {
      setWidth(ref.current.offsetWidth);
    }
  }, [currentIndex, words, suffix]);

  return (
    <span 
      className={`relative inline-block transition-all duration-500 ease-in-out align-baseline ${className}`}
      style={{ width: width ? width + 4 : 'auto' }}
    >
      {/* Invisible element to measure the active word width */}
      <span ref={ref} className="invisible absolute whitespace-nowrap">
        {words[currentIndex]}{suffix}
      </span>
      {words.map((word, i) => (
        <span
          key={i}
          className={`absolute left-0 top-0 transition-opacity duration-1000 ease-in-out whitespace-nowrap ${
            i === currentIndex ? "opacity-100" : "opacity-0 invisible"
          }`}
        >
          {word}{suffix}
        </span>
      ))}
      {/* Maintain height with an invisible static character */}
      <span className="invisible select-none pointer-events-none">X</span>
    </span>
  );
};

export default RotatingWord;
